import type { ComponentProps, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { rem } from 'polished'
import type { _BaseButtonSize } from './BaseButton'
import _BaseButton from './BaseButton'

const sizeStyles = css`
  &:where(.size-xsmall) {
    --icon-button-size: ${rem(20)};
    --icon-button-icon-size: ${rem(20)};
  }

  &:where(.size-small) {
    --icon-button-size: ${rem(28)};
    --icon-button-icon-size: ${rem(20)};
  }

  &:where(.size-medium) {
    --icon-button-size: ${rem(40)};
    --icon-button-icon-size: ${rem(20)};
  }

  &:where(.size-large) {
    --icon-button-size: ${rem(48)};
    --icon-button-icon-size: ${rem(24)};
  }
`

const StyledBaseButton = styled(_BaseButton)`
  --button-height: var(--icon-button-size);
  --button-padding-x: 0;
  --button-outdent-inline-amount: calc((var(--icon-button-size) - var(--icon-button-icon-size)) / 2);
  --button-outdent-block-amount: calc((var(--icon-button-size) - var(--icon-button-icon-size)) / 2);

  width: var(--icon-button-size);

  > svg:first-of-type {
    flex-shrink: 0;
    height: var(--icon-button-icon-size, auto);
    width: var(--icon-button-icon-size, auto);
  }

  ${sizeStyles}
`

interface Props extends ComponentProps<typeof _BaseButton> {
  /** Place the icon this button should show here */
  children: ReactNode
  /**
   * Determines the height/width of the button as well as the size of icons if they are provided
   *
   * @default medium
   *  */
  size?: _BaseButtonSize | 'xsmall'
}

function IconButton({
  className,
  shape = 'square',
  size = 'medium',
  ...rest
}: Props) {
  return <StyledBaseButton
    {...rest}
    shape={shape}
    size={size}
    className={className}
  />
}

export default IconButton
